import { HttpContextToken } from '@angular/common/http';

export const SKIP_ERROR_INTERCEPT = new HttpContextToken<boolean>(() => false);
